












import { Component, Vue } from "vue-property-decorator";
import { DelegateCount, LastBlock, TotalForged } from "@/components/monitor/header";

@Component({
  components: {
    DelegateCount,
    LastBlock,
    TotalForged,
  },
})
export default class MonitorHeader extends Vue {}
